import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./style.css";
const items = [
  { label: "Facilities", url: "facilities" },
  { label: "Active Users", url: "activeusers" },
  { label: "Amenities", url: "amenities" },
  { label: "Reviews", url: "reviews" },
  { label: "Payments", url: "payments" },
  { label: "Trainers", url: "trainers" },
  {
    label: "Notes",
    url: "notes"
  }
];
const acl = localStorage.getItem("restricted_access");
/*
  If account has access restrictions remove Active Users, Reviews and Payments from gym menu.
*/
const menuItems = items
.map(item => (
  acl === "true" 
  && (item.url == "activeusers" 
  || item.url == "reviews" 
  || item.url == "payments"))
  ? undefined
  : item)
.filter(dirtyList => dirtyList !== undefined);

class GymNavigation extends Component {
  menu = menuItems.map((currentVal, index, arr) => {
    let classes = "";
    classes += "div_navigationItem ";
    classes += index === 0 ? "div_navigationItem_first" : "";
    classes += index + 1 === arr.length ? "div_navigationItem_last" : "";
    if (window.location.pathname.search(currentVal.url) > -1)
      classes += " div_navigationItem_Selected ";
    return (
      <div style={style.navigationItem} className={classes} key={index}>
        <Link to={`/gyms/gym/${currentVal.url}`} style={style.anchor}>
          <p style={style.linkText}>{currentVal.label}</p>
        </Link>
        {/* <a href={currentVal.url} style={style.anchor}>
          <p style={style.linkText}>{currentVal.label}</p>
        </a> */}
      </div>
    );
  });

  render() {
    return <div style={style.wrapper}>{this.menu}</div>;
  }
}

export default GymNavigation;

const style = {
  wrapper: {
    display: "flex",
    justifyContent: "center"
  },
  navigationItem: {
    display: "flex",
    flexWrap: "nowrap",
    padding: "0px 30px 0px 30px",
    borderBottom: "1px solid #ccc"
  },
  anchor: {
    textDecoration: "none"
  },
  linkText: {
    color: "#444445",
    fontSize: "20px",
    margin: "0px",
    marginTop: "25px",
    marginBottom: "10px"
  }
};
